// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-330d713e] .el-table .fixed-width .el-button--mini {\n  display: block;\n}\n[data-v-330d713e] .cur-active {\n  background: #ecf5ff !important;\n}\n[data-v-330d713e] tr {\n  background: white !important;\n}\n.dict-radio[data-v-330d713e] {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  transform: translateY(-20%);\n}\n", ""]);
// Exports
module.exports = exports;
